export default function (url) {
  if (/^(f|ht)t(p|ps)?:\/\//i.test(url)) {
    return true
  } else {
    return false
  }
}
